import dateFnsFormat from 'date-fns/format';
import formatDistance from 'date-fns/formatDistance';
import parseISO from 'date-fns/parseISO';

/**
 *
 * @param {Date | string} dateOrIsoString
 * @returns string
 */
export function iso8601Date(dateOrIsoString) {
  return format(dateOrIsoString, 'yyyy-MM-dd');
}

/**
 *
 * @param {Date | string} dateOrIsoString
 * @returns string
 */
export function mmDd(dateOrIsoString) {
  return format(dateOrIsoString, 'M/d');
}

/**
 *
 * @param {Date | string} dateOrIsoString
 * @returns string
 */
export function mmDdYyyy(dateOrIsoString) {
  return format(dateOrIsoString, 'M/d/yyyy');
}

/**
 *
 * @param {Date | string} dateOrIsoString
 * @returns string
 */
export function hMmA(dateOrIsoString) {
  return format(dateOrIsoString, 'h:mm a');
}

/**
 *
 * @param {Date | string} dateOrIsoString
 * @returns string
 */
export function hhMmA(dateOrIsoString) {
  return format(dateOrIsoString, 'hh:mm a');
}

/**
 *
 * @param {Date | string} dateOrIsoString
 * @returns string
 */
export function distanceInWords(dateOrIsoString) {
  const now = new Date();
  const then = toDate(dateOrIsoString);
  return formatDistance(then, now);
}

/**
 *
 * @param {Date | string} dateOrIsoString
 * @param {string} template
 * @returns string
 */
export function format(dateOrIsoString, template) {
  const date = toDate(dateOrIsoString);
  return dateFnsFormat(date, template);
}

/**
 *
 * @param {Date | string} dateOrIsoString
 * @returns Date
 */
export function toDate(dateOrIsoString) {
  return typeof dateOrIsoString === 'string'
    ? parseISO(dateOrIsoString)
    : dateOrIsoString;
}

/**
 * Regex for "MM/DD/YYYY":
 */
export const localDateRegex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;

/**
 * Pre-condition: `localDateString` is a string formatted like "MM/DD/YYYY";
 *
 * @param {string} localDateString
 * @returns string
 */
export function localDateToISO(localDateString) {
  const [mm, dd, yyyy] = localDateString.split('/');
  return `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
}

/**
 * Pre-condition: `isoDateString` is a string formatted like "YYYY-MM-DD";
 *
 * @param {string} isoDateString
 * @returns string
 */
export function ISODateToLocal(isoDateString) {
  const [yyyy, mm, dd] = isoDateString.split('-');
  return `${mm}/${dd}/${yyyy}`;
}
